<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
import { getJsapiTicket } from '@/api/common';
import sha1 from 'js-sha1';
import { getAppId } from '@/utils/utils';

// openId,    // 当前登录用户的open id，要确保与生成signature使用的user_access_token相对应
// signature, // 签名
// appId,     // 应用 appId，在Step1中获得的应用appId
// timestamp, // 时间戳（毫秒）
// nonceStr,  // 随机字符串
// url,       // app URL
// jsApiList, // 使用成员名片组件时取值为 ['user_profile']
// locale,

export default {
  data() {
    return {
      authConfig: {
        isAuth: false
      }
    };
  },
  async mounted() {
    let options = await this.getOption();
    window.webComponent
      .config({
        ...options
      })
      .then(res => {
        this.authConfig.isAuth = true;
      });
  },
  provide() {
    return { authConfig: this.authConfig };
  },
  methods: {
    async getOption() {
      let res = await getJsapiTicket();
      let jsApiTicker = res.data.ticket;
      let openId = res.data.openId;
      let timestamp = new Date().valueOf();
      let nonceStr = 'noncekdi' + Math.floor(Math.random() * 10000);
      let url = location.origin + location.pathname;
      let str = `jsapi_ticket=${jsApiTicker}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`;
      let signature = sha1(str);
      let appId = getAppId();
      // let openId = this.userInfo.larkOpenId || 'ou_e0bea6fdfea45e13b602d87d3d2051dc';
      return {
        str,
        openId, // 当前登录用户的open id，要确保与生成signature使用的user_access_token相对应
        signature, // 签名
        appId, // 应用 appId，在Step1中获得的应用appId
        timestamp, // 时间戳（毫秒）
        nonceStr, // 随机字符串
        url, // app URL
        jsApiList: ['user_profile']
      };
    }
  }
};
</script>
